import {ContactlessType} from '../pro-tasks-manager/form/pro-tasks-form-state.service';
import {PoiUnveroEntry} from '../pro-tasks-manager/form/model/unvero/poi-unvero.entry';
import {ProductPrice} from '../pro-tasks-manager/form/properties/fuel-chart/fuel-calculation.utils';

const UNVERO_MOBILE_PAYMENT_TYPES = ['mobile', 'card_and_mobile'];

const UNVERO_BRAND_TO_CONTACTLESS: Record<string, ContactlessType> = {
  SHELL: 'SHELL',
  Viada: 'VIADA',
  BP: 'VIADA',
  Milda: 'VIADA',
  Kvistija: 'VIADA',
  Abromika: 'VIADA',
  AS24: 'AS24',
  CircleK: 'CIRCLE_K',
};

export class UnveroUtils {

  public static priceToShow(station: PoiUnveroEntry, priceToUse: ProductPrice): number {
    if (priceToUse === 'diesel') {
      return this.getDieselPrice(station);
    } else if (priceToUse === 'adBlue') {
      return this.getAdBluePrice(station)
    } else if (priceToUse === 'lng') {
      return this.getLngPrice(station)
    }
  }

  private static getDieselPrice(station: PoiUnveroEntry): number {
    let dieselProduct = station.products.find(it => it.name === 'DIESEL');
    if (dieselProduct.totalCost != null && dieselProduct.totalCost > 0) {
      return dieselProduct.totalCost;
    }
    return dieselProduct
      ? dieselProduct.price
      : 0.0;
  }

  private static getAdBluePrice(station: PoiUnveroEntry): number {
    let adBlueProduct = station.products.find(it => it.name === 'AD BLUE');
    if (adBlueProduct.totalCost != null && adBlueProduct.totalCost > 0) {
      return adBlueProduct.totalCost;
    }
    return adBlueProduct
      ? adBlueProduct.price
      : 0.0;
  }

  private static getLngPrice(station: PoiUnveroEntry): number {
    let lngProduct = station.products.find(it => it.name === 'gplc');
    return lngProduct
      ? lngProduct.price
      : 0.0;
  }

  public static resolveUnveroContactless(station: PoiUnveroEntry): ContactlessType | null {
    return station != null
    && station.externalPoiId != null
    && station.paymentType != null
    && station.brand != null
    && UNVERO_MOBILE_PAYMENT_TYPES.includes(station.paymentType)
    && UNVERO_BRAND_TO_CONTACTLESS[station.brand] != null
      ? UNVERO_BRAND_TO_CONTACTLESS[station.brand] ?? null
      : null;
  }
}
